import { createSlice } from '@reduxjs/toolkit';
import { Country } from '@global/types/types';
import { getCountries } from '@global/store/slices/country/extraReducers/getCountries';
import { SiteConfig } from '@src/global/utils/SiteConfig';

const initialState = {
  countries: [] as Country[],
  wPricingCountry: '' as string,
  wPricingRegion: '' as string,
} as const;

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.fulfilled, (state, { payload }) => {
      state.countries = payload;

      const { wPricingCountry, wPricingRegion } = getTmpPricingData(payload);

      state.wPricingCountry = wPricingCountry;
      state.wPricingRegion = wPricingRegion;
    });
  },
});

export const {} = countrySlice.actions;
export const countryReducer = countrySlice.reducer;

function getTmpPricingData(countries: Country[]) {
  const { iso } = SiteConfig.getConfig();
  const country = countries?.find(
    (country) => country.isoCodeTwo === iso?.toUpperCase()
  );

  return {
    wPricingCountry: iso,
    wPricingRegion: country.fallbackCountry,
  };
}
